import React from 'react';
import { HashRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import './App.css';
import "/node_modules/flag-icons/css/flag-icons.min.css";

/* 
  Header component with "My Portfolio" 
  and updated navbar styling.
*/
function Header() {
  return (
    <header className="app-header">
      <h1>Junho's website</h1>
      <nav className="navbar">
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/ECDOsim">ECDOsim</Link></li>
          <li><Link to="/about">About</Link></li>
          <li><Link to="/contact">Contact</Link></li>
        </ul>
      </nav>
    </header>
  );
}

/* 
  Home component:
  - Papers Section with revised “Download Buttons”
  - Data Visualizations with embedded video & images 
*/
function Home() {
  return (
    <div className="container">

      <p>🌹 BTC addy 🌹</p>

      <code style={{ fontSize: "0.5em" }}>
        bc1q0nrm2l0lr2vmcwdkh6c084tdnhfs0ama8dkfr4
      </code>

      <p>🌹 ETH addy 🌹</p>
      <code style={{ fontSize: "0.5em" }}>
        0xf6cc4e4fc962425685b06771ed453f2bd22edb26
      </code>

      <p>🌟 ECDOsim Fluid Simulation Render Package Store 🌟</p>
          <a href="https://junhobtc.sellfy.store/" target="_blank" rel="noopener noreferrer" download>
      Sellfy Online Store Link (Click Here)
    </a>

{/* --------------------------------------- 1st of 4 ----------------------------------------------------------------- */}

{/*
  
          <section className="papers">
        <h2>ECDO Civilian Prep Guide Research Paper (Published July 2025)</h2>

        <div className="paper">
          <h3>ECDO Paper 4: Civilian’s Guide to ECDO Survival - Future Steps</h3>
          <p>
            A research paper explaining how a civilian should prepare for an ECDO cataclysm, along with specific safe spots. Also covers present-day nuclear and biological weapon use.
          </p>
          <div className="download-links">

            <a href="/ECDO4eng.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-um"></span>&nbsp;
                Download (English)
              </button>
            </a>

            <a href="/ECDO4chn.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-cn"></span>&nbsp;
                下载 (中文)
              </button>
            </a>

          </div>
        </div>
</section>

*/}


{/* ---------------------------------- 2nd of 4 ---------------------------------------------------------------------- */}

{/*

      <section className="papers">
        <h2>ECDO Present-Day Evidence Research Paper (Published June 2025)</h2>

        <div className="paper">
          <h3>ECDO Paper 3: Evidence of Present-Day Western Ruling Powers’ Preparation for an Imminent Geophysical Cataclysm</h3>
          <p>
            A research paper focusing on present-day political aspects of the ECDO theory, including whistleblower testimonies, geopolitical machinations, and extensive underground bunker networks.
          </p>
          <div className="download-links">

            <a href="/ECDO3chn.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-cn"></span>&nbsp;
                下载 (中文)
              </button>
            </a>

            <a href="/ECDO3eng.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-um"></span>&nbsp;
                Download (English)
              </button>
            </a>

                        <a href="/ECDO3grm.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-de"></span>&nbsp;
                Herunterladen (Deutsch)
              </button>
            </a>

                        <a href="/ECDO3ind.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-id"></span>&nbsp;
                Download (Indonesia)
              </button>
            </a>

            <a href="/ECDO3jpn.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-jp"></span>&nbsp;
                ダウンロード (日本語)
              </button>
            </a>

                                    <a href="/ECDO3khmer.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-kh"></span>&nbsp;
                Download (Khmer)
              </button>
            </a>

                        <a href="/ECDO3kor.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-kr"></span>&nbsp;
                다운로드 (한국어)
              </button>
            </a>

                        <a href="/ECDO3malay.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-my"></span>&nbsp;
                Download (Malay)
              </button>
            </a>


            <a href="/ECDO3rus.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-ru"></span>&nbsp;
                Скачать (Русский)
              </button>
            </a>


            <a href="/ECDO3spn.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-es"></span>&nbsp;
                Descargar (Español)
              </button>
            </a>

                        <a href="/ECDO3thai.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-th"></span>&nbsp;
                Download (Thai)
              </button>
            </a>

            <a href="/ECDO3viet.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-vn"></span>&nbsp;
                Tải xuống (Tiếng Việt)
              </button>
            </a>

          </div>
        </div>
</section>

*/}


{/* ----------------------------- 3rd of 4 --------------------------------------------------------------------------- */}




      {/* Research Papers Section */}
      <section className="papers">
        <h2>ECDO Evidence Research Papers (Published February 2025)</h2>

        {/* Paper 1 */}
        <div className="paper">
          <h3>ECDO Data-Driven Primer Part 1/2: Current Understanding of the Exothermic Core-Mantle Decoupling Dzhanibekov Oscillation (ECDO) Theory</h3>
          <p>
            A research paper summarizing 6 months of independent research into the ECDO theory. Covers the evidence, cause, and future timing of the theory.
          </p>
          <div className="download-links">

<a href="/ECDO1chn.pdf" target="_blank" rel="noopener noreferrer" download>
  <button className="download-btn">
    <span className="fi fi-cn"></span>&nbsp;
    下载 (中文)
  </button>
</a>

<a href="/ECDO1eng.pdf" target="_blank" rel="noopener noreferrer" download>
  <button className="download-btn">
    <span className="fi fi-um"></span>&nbsp;
    Download (English)
  </button>
</a>

                        <a href="/ECDO1ind.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-id"></span>&nbsp;
                Download (Indonesia)
              </button>
            </a>

            <a href="/ECDO1jpn.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-jp"></span>&nbsp;
                ダウンロード (日本語)
              </button>
            </a>


                                    <a href="/ECDO1khmer.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-kh"></span>&nbsp;
                Download (Khmer)
              </button>
            </a>

            <a href="/ECDO1kor.pdf" target="_blank" rel="noopener noreferrer" download>
  <button className="download-btn">
    <span className="fi fi-kr"></span>&nbsp;
    다운로드 (한국어)
  </button>
</a>

                        <a href="/ECDO3malay.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-my"></span>&nbsp;
                Download (Malay)
              </button>
            </a>

            <a href="/ECDO1rus.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-ru"></span>&nbsp;
                Скачать (Русский)
              </button>
            </a>

                        <a href="/ECDO1thai.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-th"></span>&nbsp;
                Download (Thai)
              </button>
            </a>

<a href="/ECDO1spn.pdf" target="_blank" rel="noopener noreferrer" download>
  <button className="download-btn">
    <span className="fi fi-es"></span>&nbsp;
    Descargar (Español)
  </button>
</a>


<a href="/ECDO1viet.pdf" target="_blank" rel="noopener noreferrer" download>
  <button className="download-btn">
    <span className="fi fi-vn"></span>&nbsp;
    Tải xuống (Tiếng Việt)
  </button>
</a>

</div>
        </div>


{/* --------------------------------------4th of 4 ------------------------------------------------------------------ */}

        {/* Paper 2 */}
        <div className="paper">
          <h3>ECDO Data-Driven Primer Part 2/2: Scientific and Historical Anomalies Best Explained by an ECDO Flip</h3>
          <p>
            An additional part to the first paper explaining the diverse evidence supporting past ECDO Earth flips.
          </p>
          <div className="download-links">

<a href="/ECDO2chn.pdf" target="_blank" rel="noopener noreferrer" download>
  <button className="download-btn">
    <span className="fi fi-cn"></span>&nbsp;
    下载 (中文)
  </button>
</a>

<a href="/ECDO2eng.pdf" target="_blank" rel="noopener noreferrer" download>
  <button className="download-btn">
    <span className="fi fi-um"></span>&nbsp;
    Download (English)
  </button>
</a>

                        <a href="/ECDO2ind.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-id"></span>&nbsp;
                Download (Indonesia)
              </button>
            </a>

            <a href="/ECDO2jpn.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-jp"></span>&nbsp;
                ダウンロード (日本語)
              </button>
            </a>


                                    <a href="/ECDO2khmer.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-kh"></span>&nbsp;
                Download (Khmer)
              </button>
            </a>

            <a href="/ECDO2kor.pdf" target="_blank" rel="noopener noreferrer" download>
  <button className="download-btn">
    <span className="fi fi-kr"></span>&nbsp;
    다운로드 (한국어)
  </button>
</a>

                        <a href="/ECDO2malay.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-my"></span>&nbsp;
                Download (Malay)
              </button>
            </a>

            <a href="/ECDO2rus.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-ru"></span>&nbsp;
                Скачать (Русский)
              </button>
            </a>

                        <a href="/ECDO2thai.pdf" target="_blank" rel="noopener noreferrer" download>
              <button className="download-btn">
                <span className="fi fi-th"></span>&nbsp;
                Download (Thai)
              </button>
            </a>

<a href="/ECDO2spn.pdf" target="_blank" rel="noopener noreferrer" download>
  <button className="download-btn">
    <span className="fi fi-es"></span>&nbsp;
    Descargar (Español)
  </button>
</a>


<a href="/ECDO2viet.pdf" target="_blank" rel="noopener noreferrer" download>
  <button className="download-btn">
    <span className="fi fi-vn"></span>&nbsp;
    Tải xuống (Tiếng Việt)
  </button>
</a>


          </div>
        </div>
        <p>The ECDO research on which these papers are based can be viewed <a href="https://github.com/sovrynn/ecdo" target="_blank" rel="noopener noreferrer">here on Github</a>.</p>
    


      </section>


    {/* -------------------------------------- data viz ------------------------------------------------------------------ */}
      
      {/* Data Visualization Section */}
      <section className="visualizations">
        <h2>Geophysical Data Visualizations</h2>

<div className="visualization-card">
            <h2>ECDOsim Production Movie (Released November 2025)</h2>
            <p>
            <a href="https://mega.nz/file/vFc3wSRa#CQQkTmxjpS6orycDYLDj7XaPY1fVXtCt-yfjuvRWeLU" target="_blank" rel="noopener noreferrer">
              Download ECDOsim production movie (4k, 30fps) here (Released November 2025).
            </a>
            </p>
                      </div>

<div className="visualization-card">
            <h2>ECDOsim v11 Main Release (Released November 2025)</h2>
                                  <p>
            <a href="https://mega.nz/file/2ANwDBZB#QpFJtssEy9LO4DNXkeZR8gqxwfNhk6u-B-7DH_bqyhw" target="_blank" rel="noopener noreferrer">
              Download v11 main release S1 -> S2 (4096x4096 pixels) here.
            </a>
            </p>
                                  </div>

                                                    <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v12-sotam.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.2 features a fluid resolution increase by clipping each projection's sim to only have half the Earth's surface area. Water is reflected between the two halves, creating an additional distortion. Additionally, the relative height of the terrain (and fluid) is scaled up by 2, increasing the height-resolution of the fluid against the terrain.</p>
          </div>  


                            <div className="visualization-card">
            <img 
              className="responsive-media"
              src="/legend-final.png"
              alt="Placeholder" 
            />
            <p className="viz-caption">ECDOsim legend showing the information that has been included in the terrain coloring.
</p>
          </div>

          <div className="visualization-card">
            <img 
              className="responsive-media"
              src="/mercator.png"
              alt="Placeholder" 
            />
            <p className="viz-caption">Map of Earth's geological rock, terrain, marine fossils, and salt.
</p>
          </div>


          <div className="visualization-card">
            <img 
              className="responsive-media"
              src="/roraima-labels.png"
              alt="Placeholder" 
            />
            <p className="viz-caption">Volcanic and sedimentary layers of the Earth, visualized around Roraima (western ECDO pivot).
</p>
          </div>

                              <div className="visualization-card">
            <img 
              className="responsive-media"
              src="/roraima-naked2.png"
              alt="Placeholder" 
            />
            <p className="viz-caption">Full resolution version.
</p>
          </div>

          <div className="visualization-card">
            <img 
              className="responsive-media"
              src="/labels-edited.png"
              alt="Placeholder" 
            />
            <p className="viz-caption">Volcanic and sedimentary layers of the Earth, visualized around Sulawesi (eastern ECDO pivot).
</p>
          </div>

                    <div className="visualization-card">
            <img 
              className="responsive-media"
              src="/basic.png"
              alt="Placeholder" 
            />
            <p className="viz-caption">Full resolution version.
</p>
          </div>

                              <div className="visualization-card">
            <img 
              className="responsive-media"
              src="/peaks.png"
              alt="Placeholder" 
            />
            <p className="viz-caption">High prominence (2000m+) mountain peaks.
</p>
          </div>

          <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/1590-30fps.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">A timelapse of geomagnetic field values from 1590-2025, created using <a href="https://geomag.colorado.edu/gufm1" target="_blank" rel="noopener noreferrer">gufm1</a> and <a href="https://www.ncei.noaa.gov/products/international-geomagnetic-reference-field" target="_blank" rel="noopener noreferrer">IGRF-14</a> models (Spliced at 1900).</p>
          </div>

                              <div className="visualization-card">
            <img 
              className="responsive-media"
              src="/kml.png"
              alt="Placeholder" 
            />
            <p className="viz-caption">Various ECDO data such as fossils, salt, flood myths, and coal compiled into 3D KML format. <a href="https://github.com/sovrynn/ecdo/tree/master/5-TOOLS-DEV/dev/0-completed-kmls" target="_blank" rel="noopener noreferrer">Download here.</a>
</p>
          </div>
        
                    <div className="visualization-card">
            <img 
              className="responsive-media"
              src="/fossils.png"
              alt="Placeholder" 
            />
            <p className="viz-caption">A map showing the locations of marine (oceanic) fossils and salt. Sources: <a href="https://www.hydrosheds.org/products/glwd" target="_blank" rel="noopener noreferrer">GLWD v2</a>

, <a href="https://paleobiodb.org/#/" target="_blank" rel="noopener noreferrer">PBDB</a>

</p>
          </div>

                              <div className="visualization-card">
            <img 
              className="responsive-media"
              src="/overlaid.png"
              alt="Placeholder" 
            />
            <p className="viz-caption">Rotation speed and flood myths visualized.

, <a href="https://paleobiodb.org/#/" target="_blank" rel="noopener noreferrer">PBDB</a>

</p>
          </div>

                              <div className="visualization-card">
            <img 
              className="responsive-media"
              src="/website-final2.png"
              alt="Placeholder" 
            />
            <p className="viz-caption">A map showing the position of the geomagnetic north pole from 1590 to 2025. Source: <a href="https://www.ncei.noaa.gov/products/wandering-geomagnetic-poles" target="_blank" rel="noopener noreferrer">NCEI</a>

 </p>
          </div>
                                        <div className="visualization-card">
            <img 
              className="responsive-media"
              src="/saa-tip.png"
              alt="Placeholder" 
            />
            <p className="viz-caption">A tipping point date prediction using the South Atlantic Anomaly's surface area. To be clear, such models are only estimates. Calculated using <a href="https://geomag.colorado.edu/gufm1" target="_blank" rel="noopener noreferrer">gufm1</a> and <a href="https://www.ncei.noaa.gov/products/international-geomagnetic-reference-field" target="_blank" rel="noopener noreferrer">IGRF-14</a> models.

 </p>
          </div>
                                                  <div className="visualization-card">
            <img 
              className="responsive-media"
              src="/saa-plot-cred.png"
              alt="Placeholder" 
            />
            <p className="viz-caption">A timeseries of the South Atlantic Anomaly surface area extent from 1590-2025. Calculated using <a href="https://geomag.colorado.edu/gufm1" target="_blank" rel="noopener noreferrer">gufm1</a> and <a href="https://www.ncei.noaa.gov/products/international-geomagnetic-reference-field" target="_blank" rel="noopener noreferrer">IGRF-14</a> models.

 </p>
          </div>

                                <div className="visualization-card">
            <img 
              className="responsive-media"
              src="/flood-stories.png"
              alt="Placeholder" 
            />
            <p className="viz-caption">A map showing the locations of major flood stories around the world. Source: <a href="https://talkorigins.org/faqs/flood-myths.html" target="_blank" rel="noopener noreferrer">TalkOrigins</a>
</p>
          </div>
          
      </section>
    </div>

  );
}

/* 
  Blog component:
  - Capped at 700px width 
  - Left-aligned headers 
  - Example blog entry sections
*/
function Blog() {
  return (
    <main className="blog-container">
      <h2>Blog</h2>
      <section>
        <p>Mar 12, 2024</p>
        <a href="../blog/0044/index.html">Price Predictions</a>
      </section>
      {/* Add more sections as needed */}
    </main>
  );
}

/*
  Contact component (stays the same, or customize as desired)
*/
function Contact() {
  return (
    <div className="contact-box">
      <p>
        <span className="icon mail-icon" />
        Email: junhobtc@proton.me
      </p>
      <p>
        <span className="icon twitter-icon" />
        Twitter/X:&nbsp;
        <a
          href="https://x.com/junhoBTC"
          target="_blank"
          rel="noopener noreferrer"
        >
          @junhoBTC
        </a>
      </p>
            <p>
        Github: <a href="https://github.com/sovrynn/ecdo">ecdo</a>
      </p>
    </div>
  );
}

/*
  Contact component (stays the same, or customize as desired)
*/
function About() {
  return (
    <div className="about-container">
      <p>
      Welcome to my website!
      </p>
      <p>
      I'm a human being, with a background in software engineering.
      </p>
      <p>
      I've been independently researching ECDO (Exothermic Core-Mantle Dzhanibekov Oscillation) theory since mid-2024. At this point, I think this topic needs significantly more awareness than it has right now.
      </p>
      <p>
      I've been making most of my research publicly available; it can be viewed <a href="https://github.com/sovrynn/ecdo" target="_blank" rel="noopener noreferrer">here on Github</a>.
      </p>
    </div>
  );
}

/*
  Contact component (stays the same, or customize as desired)

  Version 1 featured a primitive Sulawesi and an improved Roraima sim with a broken water movement.

  Version 2 featured a fixed Roraima with fixed water movement.

  Version 3 featured a slight reduction of the Vortex force along with both Roraima and Sulawesi to achieve approximately expected inundation.

  Version 4 featured a bicameral overlay of the Roraima and Sulawesi pivots (adopted moving forward) and a an (incorrect) pressure gradient on the outer half surface area pulling in. An incomplete physics tweak. 

  Version 5 featured another bicameral overlay with an overly applied pressure gradient (acting at all times).

  Version 6 replaced the pressure gradient with an inward linearly pulling force proportional to the radius.

  Version 7 halved the inward radius-proportional pulling force, and was declared the first model to achieve equivalent results between the two projections.
*/
function ECDOsim() {
  return (
    <div className="container">

          <hr style={{ width: "100%", height: "2px", backgroundColor: "#000", border: "none" }} />


      <h1>Introduction</h1>

      <hr style={{ width: "100%", height: "2px", backgroundColor: "#000", border: "none" }} />


              <section className="papers">

        {/* Paper 1 */}
        <div className="paper">
          <h3>ECDOsim Explainer (Developed Oct-Nov 2025)</h3>
          <p>
            ECDOsim simulates the oceanic displacement (flooding) that would occur during an exothermic core-mantle decoupling Dzhanibekov oscillation (ECDO) cataclysm event, in which the Earth's crust is hypothesized to accelerate and find a new stable rotational position around a rotational axis which intersects two pivot points on Earth's surface. This would lead to a global flood.
          </p>
          <p>
            ECDOsim bases the projection around a 2D Lambert azimuthal equal-area projection centered around the two pivot points, which lie directly opposite each other on Earth's surface. This projection preserves the radial lines of force imparted onto the fluid by the rotating land, and thus spins the water in a vortex field. The acceleration is fastest at the start and then oscillates to 0 in a pendulum-like motion. The model has been carefully tuned to match the evidence, which includes ancient flood stories, marine fossils, sediment deposits, and salt.
          </p>
            Basic sim notes:
            <ul>
              <li>The terrain is scaled up significantly (10x+) in height relative to length and width, which distorts the liquid volume per particle to have less height and more width and length. Since the water depth and volume are also increased when doing this, it shouldn't change the simulation output.</li>
              <li>The terrain is overlaid with a basemap that combines an elevation color gradient with a map showing sedimentary (blue) and volcanic (red) rock surface layers. In later versions, blue dots, representing mostly salt and marine fossils, but also coal/oil/gas mines, were added to the terrain map. In v11, country borders (white lines), tectonic boundaries (black lines), and volcanoes (black dots) were added.</li>
              <li>Theoretically, the simulation is supposed to return the exact same results in both projections. However, the simulation is imperfect.</li>
              <li>The cross at the center of the video represents the displacement in position of the Earth (and water) over the duration of the video, oscillating to a displacement of 104 degrees from the initial state, synchronized with the vortex motion of the water.</li>
              <li>Versions v10 and onward also have informational labels in the 4 video corners providing various kinds of information.</li>
            </ul>

            Regarding the technical specifications:
            <ul>
              <li>There have been eleven versions of the model so far - v1 through v11. Each was released as an improvement upon the previous.</li>
              <li>The fluid resolution was first adjusted in v1, remained the same until v8, and began to increase in each version from v9 onwards. The fluid resolution is proportional to the number of particles.</li>
              <li>The terrain remained the same resolution of about 1.5 million pixels through v9, was increased to 3.4 million pixels in v10, and finally, 13.7 million pixels in v11.</li>
              <li>The simulation's domain spans the Earth's entire surface area of 510 million square kilometers at a depth of ~-10k m low to ~12k m high. The border of the terrain is set to 15k m high.</li>
              <li>The particle count is about 12 million throughout v1-v8, implying a cubic volume of 108 cubic kilometers per liquid particle. This was increased in v9, and again in v10, reaching ~19 million particles in v10 (~68 km^3 per particle).</li>
              <li>The model was developed entirely on my consumer workstation through model v8, using Blender. Half of v9 and the bonus scenarios of v10/v11 were also processed on my computer. However, in v9, I also began to split the workload onto a second high-compute machine graciously lended to me.</li>
              <li>The terrain is modeled as a static mesh, with small frictional and damping forces it exerts on the fluid.</li>
            </ul>

            Regarding model design and tuning:
            <ul>
              <li>The design of the model was based on ECDO.</li>
              <li>A total of 9 different vortex pivots, all located near the ECDO pivots, were tested in order to find the inundation results that agreed most with the existing inundation evidence. As part of the tuning, I gave myself the freedom to freely change the pivots in order to better satisfy inundation requirements across the geometric terrain of Earth.</li>
              <li>A variety of Blender "physics forces" were introduced and tested in order to bring the inundation between the two projections as close as possible to each other. The forces exerted on the water have changed throughout all versions of the sim, and while the results between the two pivot projections are still not the same, I believe the results are close enough to still be useful.</li>
            </ul>
        </div>

                  <div className="visualization-card">
            <img 
              className="responsive-media"
              src="/legend-final.png"
              alt="Placeholder" 
            />
            <p className="viz-caption">ECDOsim legend showing the information that has been included in the terrain coloring.
</p>
          </div>

</section>

      <hr style={{ width: "100%", height: "2px", backgroundColor: "#000", border: "none" }} />

      <h1>ECDOsim v15 Bonus Movie</h1>

      <hr style={{ width: "100%", height: "2px", backgroundColor: "#000", border: "none" }} />

          <section className="visualizations">

            <p>
            <a href="https://mega.nz/file/SJdhUSaa#5x3kDobGy6sbCirHz888_H8xy5KDfpvQVCmK-WRrnsY" target="_blank" rel="noopener noreferrer">
              Download ECDOsim v15 bonus movie (1080p, 30fps) here (Released December 2025).
            </a>
            </p>

      </section>

      <hr style={{ width: "100%", height: "2px", backgroundColor: "#000", border: "none" }} />

      <h1>ECDOsim v15 (Complex Motion, Scaled Up)</h1>

      <hr style={{ width: "100%", height: "2px", backgroundColor: "#000", border: "none" }} />

    <section className="visualizations">
      <h1>ECDO Simulation Version 15: NA + Africa Event Rendition (Released December 2025)</h1>

                                                          <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v15-fun2.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.5 features a scaleup of the complex motion that combines evidence across NA and Africa to create a rendition of the most recent ECDO event.</p>
          </div>

      <h2>ECDO Simulation Version 15 Bonus Scenario 1/4: Reverse NA + Africa Rendition (Released December 2025)</h2>

                                                          <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v15-reverse.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">An exactly reversed motion of the NA + Africa event complex motion.</p>
          </div>

      <h2>ECDO Simulation Version 15 Bonus Scenario 2/4: NA + Africa Movement, S2 (Released December 2025)</h2>

                                                          <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v15-reverse-v2-full.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">The same motion of the NA + Africa event complex motion around an approximately S2 state.</p>
          </div>


      <h2>ECDO Simulation Version 15 Bonus Scenario 3/4: Strong S1 -> S2 (Released December 2025)</h2>

                                                          <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v15-s1.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">A strong S1 -> S2 motion at the v11 modified ECDO pivots.</p>
          </div>

      <h2>ECDO Simulation Version 15 Bonus Scenario 4/4: Strong S2 -> S1 (Released December 2025)</h2>

                                                          <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v15-s2.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">A strong S2 -> S1 rotation at the v11 modified ECDO pivots.</p>
          </div>

      </section>

      <hr style={{ width: "100%", height: "2px", backgroundColor: "#000", border: "none" }} />

      <h1>ECDOsim v14 (Complex 3D Motion)</h1>

      <hr style={{ width: "100%", height: "2px", backgroundColor: "#000", border: "none" }} />

    <section className="visualizations">
      <h1>ECDO Simulation Version 14: Sahara + NA Event Rendition (Released December 2025)</h1>

                                                    <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v14-path.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.4 features a complex motion that combines evidence across NA and the Sahara to create a rendition of the most recent ECDO event.</p>
          </div>

                                                              <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v14-kzn.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.4 features a complex motion that combines evidence across NA and the Sahara to create a rendition of the most recent ECDO event.</p>
          </div>  

      </section>


      <hr style={{ width: "100%", height: "2px", backgroundColor: "#000", border: "none" }} />

      <h1>ECDOsim v13 (3D Model)</h1>

      <hr style={{ width: "100%", height: "2px", backgroundColor: "#000", border: "none" }} />

    <section className="visualizations">
      <h1>ECDO Simulation Version 13: Very Weak S1 -> S2, 3D Model (Released December 2025)</h1>

                                                    <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v13.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.3 features a 3D model. The fluid resolution is much lower than a 2D model due to the extra space inside the Earth. The benchmark for this is the 12 million particle fluid resolution of v8.</p>
          </div>  

      </section>

      <hr style={{ width: "100%", height: "2px", backgroundColor: "#000", border: "none" }} />

      <h1>ECDOsim v12 (Last Lambert Experiment; 2x Height Scale)</h1>

      <hr style={{ width: "100%", height: "2px", backgroundColor: "#000", border: "none" }} />

                      {/* Data Visualization Section */}
                      {/*
    <section className="visualizations">
      <h1>ECDO Simulation Version 12: S1 -> S2, 70% Strength, Classic ECDO Pivots, Roraima Half (Released December 2025)</h1>

            <p>
            Coming soon...
            </p>

      </section>

          <section className="visualizations">
      <h1>ECDO Simulation Version 12, S1 -> S2, 50% Strength, Classic ECDO Pivots, Sulawesi Half (Released December 2025)</h1>

            <p>
            Coming soon...
            </p>

      </section>

    */}

                            <section className="visualizations">
      <h2>ECDO Simulation Version 12: Stillshots (Released December 2025)</h2>


                                                    <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v12-sotam.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.2 features a fluid resolution increase by clipping each projection's sim to only have half the Earth's surface area. Water is reflected between the two halves, creating an additional distortion. Additionally, the relative height of the terrain (and fluid) is scaled up by 2, increasing the height-resolution of the fluid against the terrain.</p>
          </div>  

                                                              <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v12-aus.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.2 features a fluid resolution increase by clipping each projection's sim to only have half the Earth's surface area. Water is reflected between the two halves, creating an additional distortion. Additionally, the relative height of the terrain (and fluid) is scaled up by 2, increasing the height-resolution of the fluid against the terrain.</p>
          </div>  

      </section>

                <section className="visualizations">
      <h2>ECDO Simulation Version 12: Bonus Scenario, (More) Realistic Height Scale Random Render (Released December 2025)</h2>


                                                    <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v12-flat.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.2 bonus scenario - a more realistic height-scale run of a random recent .blend file. Height is still scaled up significantly from reality.</p>
          </div>  

      </section>

      <hr style={{ width: "100%", height: "2px", backgroundColor: "#000", border: "none" }} />

      <h1>ECDOsim Final Release Production Movie</h1>

      <hr style={{ width: "100%", height: "2px", backgroundColor: "#000", border: "none" }} />

                {/* Data Visualization Section */}
    <section className="visualizations">

            <p>
            <a href="https://mega.nz/file/vFc3wSRa#CQQkTmxjpS6orycDYLDj7XaPY1fVXtCt-yfjuvRWeLU" target="_blank" rel="noopener noreferrer">
              Download ECDOsim production movie (4k, 30fps) here (Released November 2025).
            </a>
            </p>

      </section>

      <hr style={{ width: "100%", height: "2px", backgroundColor: "#000", border: "none" }} />

      <h1>Release Version v11</h1>

      <hr style={{ width: "100%", height: "2px", backgroundColor: "#000", border: "none" }} />

                {/* Data Visualization Section */}
    <section className="visualizations">
      <h1>ECDO Simulation Version 11: S1 -> S2, Modified Pivots (Released November 2025)</h1>

            <p>
            <a href="https://mega.nz/file/2ANwDBZB#QpFJtssEy9LO4DNXkeZR8gqxwfNhk6u-B-7DH_bqyhw" target="_blank" rel="noopener noreferrer">
              Download v11 main release S1 -> S2 (4096x4096 pixels) here.
            </a>
            </p>

      </section>

    <section className="visualizations">
      <h2>ECDO Simulation Version 11, Rotating Particle Velocity View (Released November 2025)</h2>

            <p>
            <a href="https://mega.nz/file/mREE3J4D#xCmb372JzrN3DqKg5J8mX93ABSUVid2nRzrvPk2UsT0" target="_blank" rel="noopener noreferrer">
              Download rotating particle velocity view (2500x2500 pixels) here.
            </a>
            </p>

      </section>

    <section className="visualizations">
      <h2>ECDO Simulation Version 11, Bonus Stills (Released December 2025)</h2>

                                                    <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/guiyana-redo.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.1 main release bonus still.</p>
          </div>  

                                              <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/tibet.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.1 main release bonus still.</p>
          </div>  


{/*
                                              <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/mexico.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.1 main release bonus still.</p>
          </div>      

                                              <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/indonesia.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.1 main release bonus still.</p>
          </div>      

                                              <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/israel-roraima.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.1 main release bonus still.</p>
          </div>      

                                              <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/oceania.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.1 main release bonus still.</p>
          </div>

                                                  <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/notam-final.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.1 main release bonus still.</p>
          </div>

                                                            <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/appalachians.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.1 main release bonus still.</p>
          </div>

*/}

                                        <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/europe-only.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.1 main release bonus still.</p>
          </div>

      </section>

                      {/* Data Visualization Section */}
    <section className="visualizations">
      <h2>ECDO Simulation Version 11, Bonus Scenario 1/X: "Homage" - S1 -> S2 @ 70% Strength, Classic ECDO Pivots (Released November 2025)</h2>

                            <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v11-classic.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.1 features a main scenario along with four bonus sim scenarios. All scenarios have an improved color scheme, and the main release of v11 features increased fluid/terrain/time resolution.</p>
          </div>

      </section>


                      {/* Data Visualization Section */}
    <section className="visualizations">
      <h2>ECDO Simulation Version 11, Bonus Scenario 2/X: "Mindfuck" - S2 -> S1 @ 30% Strength, Modified Pivots (Released November 2025)</h2>

                            <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v11-s2.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.1 features a main scenario along with four bonus sim scenarios. All scenarios have an improved color scheme, and the main release of v11 features increased fluid/terrain/time resolution.</p>
          </div>

      </section>

                            {/* Data Visualization Section */}
    <section className="visualizations">
      <h2>ECDO Simulation Version 11, Bonus Scenario 3/X: "Vortex Art" - Dicing the Himalayas (Released November 2025)</h2>

                            <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/vortex-art.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Vortex Art.</p>
          </div>

      </section>

                                  {/* Data Visualization Section */}
    <section className="visualizations">
      <h2>ECDO Simulation Version 11, Bonus Scenario 4/X: "The Last Dog" - Heavily Requested by Ben Davidson (Released November 2025)</h2>

                            <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v11-ben.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.1 features a main scenario along with four bonus sim scenarios. All scenarios have an improved color scheme, and the main release of v11 features increased fluid/terrain/time resolution.</p>
          </div>

      </section>

            <hr style={{ width: "100%", height: "2px", backgroundColor: "#000", border: "none" }} />

      <h1>Release Version v10</h1>

      <hr style={{ width: "100%", height: "2px", backgroundColor: "#000", border: "none" }} />

                {/* Data Visualization Section */}
    <section className="visualizations">
      <h1>ECDO Simulation Version 10: S1 -> S2, Modified ECDO Pivots (Released November 2025)</h1>

                      <div className="visualization-card">
                        <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v10-final.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.0 features a main scenario (standard S1 -> S2) along with three bonus sim scenarios (strong S1 -> S2, strong S1 -> S2 with extended drainage, and S2 -> S1). The main release of v10 features increased fluid resolution (19 mm particles), increased terrain resolution, improved physics forces, a new color scheme, and new S1 -> S2 pivots at (-20 S, 130 E) (20 N, -50 W).</p>
          </div>


{/*
                      <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v10-africa.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.0 features a main scenario (standard S1 -> S2) along with three bonus sim scenarios (strong S1 -> S2, strong S1 -> S2 with extended drainage, and S2 -> S1). The main release of v10 features increased fluid resolution (19 mm particles), increased terrain resolution, improved physics forces, a new color scheme, and new S1 -> S2 pivots at (-20 S, 130 E) (20 N, -50 W).</p>
          </div>

                                                              <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v10-notam.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.0 features a main scenario (standard S1 -> S2) along with three bonus sim scenarios (strong S1 -> S2, strong S1 -> S2 with extended drainage, and S2 -> S1). The main release of v10 features increased fluid resolution (19 mm particles), increased terrain resolution, improved physics forces, a new color scheme, and new S1 -> S2 pivots at (-20 S, 130 E) (20 N, -50 W).</p>
          </div>

                                                    <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v10-asia.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 1.0 features a main scenario (standard S1 -> S2) along with three bonus sim scenarios (strong S1 -> S2, strong S1 -> S2 with extended drainage, and S2 -> S1). The main release of v10 features increased fluid resolution (19 mm particles), increased terrain resolution, improved physics forces, a new color scheme, and new S1 -> S2 pivots at (-20 S, 130 E) (20 N, -50 W).</p>
          </div>
*/}

      </section>

                      {/* Data Visualization Section */}
    <section className="visualizations">
      <h2>ECDO Simulation Version 10, Bonus Scenario 1/3: S1 -> S2, Extended Drainage (Released November 2025)</h2>

                      <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v10-sulawesi-extended.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
             <p className="viz-caption">Version 1.0 features three bonus sim scenarios (strong S1 -> S2, S1 -> S2 with extended drainage, and S2 -> S1). This bonus scenario adds extra time to the end of the simulation by adding many extra frames.</p>
          </div>

      </section>

                      {/* Data Visualization Section */}
    <section className="visualizations">
      <h2>ECDO Simulation Version 10, Bonus Scenario 2/3: S2 -> S1 @ 90% Strength, Classic ECDO Pivots (Released November 2025)</h2>

                      <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v10-s2.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
             <p className="viz-caption">Version 1.0 features three bonus sim scenarios (strong S1 -> S2, strong S1 -> S2 with extended drainage, and S2 -> S1). This bonus scenario features increased terrain resolution, improved physics forces, a new color scheme, and the standard ECDO pivots at (0 S, 121 E) (0 N, -59 W).</p>
          </div>

      </section>

                      {/* Data Visualization Section */}
    <section className="visualizations">
      <h2>ECDO Simulation Version 10, Bonus Scenario 3/3: Strong S1 -> S2 @ 2x Strength, Modified Pivots (Released November 2025)</h2>

                      <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v10-strong.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
             <p className="viz-caption">Version 1.0 features three bonus sim scenarios (strong S1 -> S2, strong S1 -> S2 with extended drainage, and S2 -> S1). This bonus scenario features increased terrain resolution, improved physics forces, a new color scheme, and new S1 -> S2 pivots at (-20 S, 130 E) (20 N, -50 W).</p>
          </div>

{/*
                      <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v10-strong-na.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
             <p className="viz-caption">Version 1.0 features three bonus sim scenarios (strong S1 -> S2, strong S1 -> S2 with extended drainage, and S2 -> S1). This bonus scenario features increased terrain resolution, improved physics forces, a new color scheme, and new S1 -> S2 pivots at (-20 S, 130 E) (20 N, -50 W).</p>
          </div>

                      <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v10-europe-strong2.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
             <p className="viz-caption">Version 1.0 features three bonus sim scenarios (strong S1 -> S2, strong S1 -> S2 with extended drainage, and S2 -> S1). This bonus scenario features increased terrain resolution, improved physics forces, a new color scheme, and new S1 -> S2 pivots at (-20 S, 130 E) (20 N, -50 W).</p>
          </div>

                      <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v10-andes-strong.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
             <p className="viz-caption">Version 1.0 features three bonus sim scenarios (strong S1 -> S2, strong S1 -> S2 with extended drainage, and S2 -> S1). This bonus scenario features increased terrain resolution, improved physics forces, a new color scheme, and new S1 -> S2 pivots at (-20 S, 130 E) (20 N, -50 W).</p>
          </div>

                      <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v10-himalayas-strong.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
             <p className="viz-caption">Version 1.0 features three bonus sim scenarios (strong S1 -> S2, strong S1 -> S2 with extended drainage, and S2 -> S1). This bonus scenario features increased terrain resolution, improved physics forces, a new color scheme, and new S1 -> S2 pivots at (-20 S, 130 E) (20 N, -50 W).</p>
          </div>
*/}

      </section>

      <hr style={{ width: "100%", height: "2px", backgroundColor: "#000", border: "none" }} />

      <h1>Pre-Release Prototype Versions (v1-v9)</h1>

      <hr style={{ width: "100%", height: "2px", backgroundColor: "#000", border: "none" }} />

                      {/* Data Visualization Section */}
    <section className="visualizations">
      <h2>ECDO Simulation Version 9 (Released November 1, 2025)</h2>

                      <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v9-final.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 0.9 brings many substantial upgrades, featuring the first new physics forces since v6, new experimental pivots at (-15 S, 100 E) (15 N, 80 W), the first fluid resolution increase since v1, increased time resolution, and improved render settings.</p>
          </div>

                                <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v9-bastion.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 0.9 - "The Starry Bastion".</p>
          </div>

      </section>

                      {/* Data Visualization Section */}
    <section className="visualizations">
      <h2>ECDO Simulation Version 8 (Released October 28, 2025)</h2>

                      <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v8-final.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 0.8 of a global ECDO simulation changes the pivots to (12.5 N, -90 W), and (-12.5 S, 90 E) to better satisfy flooding requirements. The vortex force was also turned up 20% compared to v7.</p>
          </div>

                            <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v8-chain-of-life.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">The Chain of Life - ECDOsim v0.8.</p>
          </div>

      </section>

                  {/* Data Visualization Section */}
    <section className="visualizations">
      <h2>ECDO Simulation Version 7 (Released October 22, 2025)</h2>

                  <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v7-8fps.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 0.7 halved the strength of the newly-added inward pulling force, and was declared as the first model to achieve an (approximately) equivalent inundation result between the two projections.</p>
          </div>

                  <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v7-africa.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 0.7 of a global ECDO S1 -> S2 fluid simulation. The Earth has been projected into a Lambert Azimuthal Equal Area plane centered at the Roraima and Sulawesi ECDO pivots, which preserves fluid flow along radial lines of force at the center. Overlaid with a basemap of volcanic (red) and sedimentary (blue) surface rock layers. The water spins in a vortex field, oscillating to 0, modeling a pendulum-like dampening motion. The strength of the vortex field has been tuned to achieve the expected amount of inundation. Resulting drainage is also depicted, representing the majority of the video length.</p>
          </div>

                  <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/v7-coriolis.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">Version 0.7 of a global ECDO S1 -> S2 fluid simulation. The Earth has been projected into a Lambert Azimuthal Equal Area plane centered at the Roraima and Sulawesi ECDO pivots, which preserves fluid flow along radial lines of force at the center. Overlaid with a basemap of volcanic (red) and sedimentary (blue) surface rock layers. The water spins in a vortex field, oscillating to 0, modeling a pendulum-like dampening motion. The strength of the vortex field has been tuned to achieve the expected amount of inundation. Resulting drainage is also depicted, representing the majority of the video length.</p>
          </div>

      </section>

              {/* Data Visualization Section */}
    <section className="visualizations">
      <h2>ECDO Simulation Version 6 (Released October 22, 2025)</h2>

        <div className="visualization-card">
          <video 
            className="responsive-media"
            autoplay loop muted controls
            style={{ backgroundColor: '#fff' }}
          >
            <source src="/v6-final-16fps.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <p className="viz-caption">Version 0.6 replaced the pressure gradient force acting on the outer half, with a simple linearly inward pulling force, proportional to the radius, acting across the entire surface area. The results between the two projections were getting quite similar.</p>
        </div>

      </section>

              {/* Data Visualization Section */}
    <section className="visualizations">
      <h2>ECDO Simulation Version 5 (Released October 21, 2025)</h2>

        <div className="visualization-card">
          <video 
            className="responsive-media"
            autoplay loop muted controls
            style={{ backgroundColor: '#fff' }}
          >
            <source src="/v5.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <p className="viz-caption">Version 0.5 featured an artificial strengthening of the pressure gradient force to try and get the inundation results between the two projections equal. In this version, the Pacific Ocean was finally brought to do similar things across both projections.</p>
        </div>

      </section>

              {/* Data Visualization Section */}
    <section className="visualizations">
      <h2>ECDO Simulation Version 4 (Released October 21, 2025)</h2>

        <div className="visualization-card">
          <video 
            className="responsive-media"
            autoplay loop muted controls
            style={{ backgroundColor: '#fff' }}
          >
            <source src="/v4-global-8fps.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <p className="viz-caption">Version 0.4 featured a second physics force to the vortex - a pressure gradient pulling inwards on the outer half of the circle's surface area. A bicameral view was also adopted showing both projections side by side. FPS was increased to better see the fluid motion.</p>
        </div>

      </section>

          {/* Data Visualization Section */}
    <section className="visualizations">
      <h2>ECDO Simulation Version 3 (Released October 19, 2025)</h2>

              <div className="visualization-card">
          <video 
            className="responsive-media"
            autoplay loop muted controls
            style={{ backgroundColor: '#fff' }}
          >
            <source src="/sulawesiv3.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <p className="viz-caption">Version 0.3 featured nothing other than a further slight reduction to the vortex force.</p>
        </div>

        <div className="visualization-card">
          <video 
            className="responsive-media"
            autoplay loop muted controls
            style={{ backgroundColor: '#fff' }}
          >
            <source src="/roraima3-global.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <p className="viz-caption">Version 0.3 featured nothing other than a further slight reduction to the vortex force.</p>
        </div>

      </section>

      {/* Data Visualization Section */}
    <section className="visualizations">
      <h2>ECDO Simulation Version 2 (Released October 19, 2025)</h2>

        <div className="visualization-card">
          <video 
            className="responsive-media"
            autoplay loop muted controls
            style={{ backgroundColor: '#fff' }}
          >
            <source src="/roraima2-fixed-vortex.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <p className="viz-caption">Version 0.2 featured a physics force fix solely on Roraima - the water was prevented from artificially being flung outwards as the vortex force reversed, and its force was reduced by half to reduce the inundation.</p>
        </div>

      </section>

    {/* Data Visualization Section */}
      <section className="visualizations">
        <h2>ECDO Simulation Version 1 (Released October 16-18, 2025)</h2>

            <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/roraima-1.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">The second clip of version 0.1 featured an improved version on the Roraima pivot at coordinates (0,-59). Water height was brought to sea level and the fluid resolution was improved.</p>
          </div>

          <div className="visualization-card">
            <video 
              className="responsive-media"
              autoplay loop muted controls
              style={{ backgroundColor: '#fff' }}
            >
              <source src="/sulawesi-v1-final.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="viz-caption">The first clip of version 0.1 of a global ECDO S1 -> S2 fluid simulation featured a primitive concept where water was rotated in a vortex field on a flat circular Lambert projection of the Earth, centered around Sulawesi at coordinates (0,121).</p>
          </div>

        </section>

    </div>

  );
}

function App() {
  return (
    <Router basename="/">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ECDOsim" element={<ECDOsim />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        {/* optional: catch-all to send unknown paths home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
